import { get, post } from '../service/axios';
import {
    apiGetUserRoles,
    apiUpdateUserName,
    apiUpdateUserPhone,
    apiUpdateUserRole,
    apiUpdateUserStatus,
} from '../api/users/users';

export type TCreateUserProp = {
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    clinic_role: number | string | null;
    password: string;
    confirm_password: string;
};

export const userService = {
    async getUsers(limit: number, offset: number) {
        return await get('/users', { params: { limit, offset } });
    },

    async createUser(data: TCreateUserProp) {
        return await post('/users/', data);
    },

    async updateUserName(id: number, firstName: string, lastName: string) {
        return await apiUpdateUserName({ id, firstName, lastName });
    },

    async updateUserPhone(id: number, phone: string) {
        return await apiUpdateUserPhone(id, phone);
    },

    async updateUserStatus(id: number) {
        return await apiUpdateUserStatus(id);
    },

    async updateUserRole(id: number, role: string | number) {
        return await apiUpdateUserRole(id, role);
    },

    async getUserRoles() {
        return await apiGetUserRoles();
    },
};
